import React, { useState, useRef } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { EditOutlined } from "@ant-design/icons";
import { Button, message, Modal } from "antd";
import { SaveOutlined, SendOutlined, EyeOutlined } from "@ant-design/icons";
import QurealRenderer from "../qureal_renderer/QurealRenderer";
import BlogEditor from "./BlogEditor";
import { useCreateItem } from "../_actions/mutations/items";
import { history } from "../_helpers/history";
import styles from "./styles/QurealBlog.module.css";

export default function QurealNewBlog({ onSave, initialData = {} }) {
    const createMutation = useCreateItem("qblog_posts", (data) => {
        console.log("Blog published successfully", data);
        message.success(
            data.status === "published"
                ? "Blog published successfully!"
                : "Draft saved successfully!"
        );
        history.push("/ecommerce/blog", {
            from: history.location.pathname,
        });
    });
    const [blogData, setBlogData] = useState({
        title: initialData.title || "",
        body: initialData.body || "",
        fullContent:
            initialData.fullContent ||
            `<h1 class="is-empty"></h1><p class="is-empty"></p>`,
    });
    const [isSaving, setIsSaving] = useState(false);
    const [isPreviewVisible, setIsPreviewVisible] = useState(false);
    const [editorInstance, setEditorInstance] = useState(null);

    // const handleEditorChange = (data) => {
    //   console.log("handleEditorChange received:", data);
    //   currentContentRef.current = data;
    // };
    const handleShowPreview = () => {
        if (!editorInstance) {
            console.error("Editor instance not available");
            return;
        }

        const currentContent = editorInstance.getCurrentContent();
        console.log("Preview content:", currentContent);

        setBlogData((prev) => ({
            ...prev,
            title: currentContent.title || prev.title,
            body: currentContent.body,
            fullContent: currentContent.fullContent,
        }));

        setIsPreviewVisible(true);
    };
    const handleSubmit = async (status = "draft") => {
        setIsSaving(true);
        try {
            // Validate form
            if (!blogData.title.trim()) {
                message.error("Please enter a title");
                setIsSaving(false);
                return;
            }
            const finalContent = editorInstance
                ? editorInstance.getHTML()
                : blogData.fullContent;
            const blogPayload = {
                title: blogData.title,
                body: blogData.body,
                fullContent: finalContent,
                status: status,
                published_date:
                    status === "published" ? new Date().toISOString() : null,
            };

            createMutation.mutate(blogPayload, {
                onError: (error) => {
                    console.error("Failed to save blog:", error);
                    message.error("Failed to save blog. Please try again.");
                },
                onSettled: () => {
                    setIsSaving(false);
                },
            });

            // Call parent save handler or API
            if (onSave) {
                await onSave(blogPayload);
            }

            message.success(
                status === "published" ? "Blog published" : "Draft saved"
            );
        } catch (error) {
            console.error("Error saving blog:", error);
            message.error("Failed to save blog");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Create New Blog"
                    icon={<EditOutlined />}
                >
                    <div className={styles.actionButtons}>
                        <Button
                            icon={<EyeOutlined />}
                            onClick={handleShowPreview}
                        >
                            Preview
                        </Button>
                        <Button
                            type="default"
                            icon={<SaveOutlined />}
                            onClick={() => handleSubmit("draft")}
                            loading={isSaving}
                        >
                            Save Draft
                        </Button>
                        <Button
                            type="primary"
                            icon={<SendOutlined />}
                            onClick={() => handleSubmit("published")}
                            loading={isSaving}
                        >
                            Publish
                        </Button>
                    </div>
                </SectionHeader>
            }
        >
            <div className={styles.editorContainer}>
                <BlogEditor
                    initialContent={blogData.fullContent}
                    // onChange={handleEditorChange}
                    onEditorInit={setEditorInstance}
                />
            </div>

            {/* Preview Modal */}
            <Modal
                open={isPreviewVisible}
                onCancel={() => setIsPreviewVisible(false)}
                footer={null}
                width={800}
            >
                <div className={styles.rendererWrapper}>
                    <QurealRenderer content={blogData.fullContent} />
                </div>
            </Modal>
        </QurealSection>
    );
}
